import { hide } from '../../cnilBanner/actions';
import { setFocus } from '../actions';

class StoreHelper {
  constructor(state, dispatch, externals) {
    this.state = state;
    this.dispatch = dispatch;
    this.externals = externals || {};
    this.closeMenu = undefined;
  }

  isHidden() {
    return this.state && typeof this.state.visible !== 'undefined' && this.state.visible === false;
  }

  isVisible() {
    return !this.isHidden();
  }

  setFocus(status) {
    this.dispatch(setFocus(status));
  }

  hasNav(url) {
    return typeof this.externals.nav === 'string' && url.startsWith('/nav/');
  }

  nav(url) {
    if (this.hasNav(url)) {
      this.dispatch({ type: this.externals.nav, url });
    }
  }

  hasSearch(url) {
    return typeof this.externals.search === 'string' && (url.startsWith('/s/') || url.startsWith('/search/'));
  }

  search(url) {
    if (this.hasSearch(url)) {
      this.dispatch({ type: this.externals.search, url });
    }
  }

  defineCloseMenu(closeMenu) {
    this.closeMenu = closeMenu;
  }

  doCloseMenu() {
    if (this.closeMenu) {
      this.closeMenu();
    }
  }

  hideCnilBanner() {
    this.dispatch(hide());
  }
}

export default StoreHelper;
